module.exports = __webpack_public_path__ + "static/media/07.6e9643cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/07.jpg
// module id = 697
// module chunks = 0